import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3faaf2dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-config-component-drawer-list-group-component" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","padding-bottom":"22px"} }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"22px","letter-spacing":"2px","font-weight":"bold","padding-right":"30px"}
}
const _hoisted_4 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_5 = ["onClick"]

import {computed, onMounted, PropType, ref, toRaw, watchEffect} from "vue";
import {AppConfigComponent, AppConfigComponentListGroupItem, AppConfigComponentListStyle} from "@/model/AppConfig";
import {
  AppConfigDatasourceItemPosition,
  AppConfigDatasourcePreviewItem
} from "@/model/AppConfigDatasource";
import AppConfigComponentDrawerDatasourceComponent
  from "@/views/appconfig/drawer/AppConfigComponentDrawerDatasourceCom.vue";
import {InfiniteScrollWay} from "@/views/appconfig/drawer/InfiniteScrollWay";
import JTabs from "@/components/JTabs/JTabs.vue";
import JTabsContent from "@/components/JTabs/JTabsContent.vue";
import PracticeSubMenuItemListView from "@/views/homepractice/PracticeSubMenuItemListView.vue";


const __default__ = {
  name: "AppConfigComponentDrawerListGroupComponent"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: true
  },

  // 是否是最后一个组件
  isLastComponent: {
    type: Boolean,
    required: false,
    default: false
  },
},
  setup(__props) {

const props = __props



const activeItem = ref<AppConfigComponentListGroupItem | null>()
const activeName = ref<string>("")

const data = ref<AppConfigDatasourcePreviewItem[]>([])

const selectItem = async (item: AppConfigComponentListGroupItem) => {
  activeName.value = item.uuid
}

const items = computed(() => {
  if (props.component.listGroup?.items) {
    return props.component.listGroup?.items.map((e) => {
      return {
        id: e.uuid,
        name: e.name
      }
    })
  }
  return []
})

watchEffect(async () => {
  if (activeItem.value == null && props.component.listGroup
      && props.component.listGroup.items && props.component.listGroup.items.length > 0) {
    await selectItem(props.component.listGroup.items[0])
  }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.component.listGroup && __props.component.listGroup.items && __props.component.listGroup.items.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            (__props.component.listGroup?.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.component.listGroup?.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.listGroup.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (activeName.value = item.uuid),
                    class: _normalizeClass([{'active': item.uuid === activeName.value}, "item"])
                  }, _toDisplayString(item.name), 11, _hoisted_5))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.component.listGroup.items, (item) => {
              return (_openBlock(), _createBlock(JTabsContent, {
                value: item.uuid,
                "active-value": activeName.value
              }, {
                default: _withCtx(() => [
                  (item.datasource)
                    ? (_openBlock(), _createBlock(AppConfigComponentDrawerDatasourceComponent, {
                        "list-style": item.style,
                        key: item.uuid,
                        style: {"min-height":"300px"},
                        length: 8,
                        "infinite-scroll": true,
                        "infinite-scroll-way": __props.isLastComponent ? _unref(InfiniteScrollWay).PAGINATION : _unref(InfiniteScrollWay).CLICK,
                        datasource: item.datasource
                      }, null, 8, ["list-style", "infinite-scroll-way", "datasource"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["value", "active-value"]))
            }), 256))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})